import { Component, inject } from '@angular/core';
import { MachinePerWorkFrontService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MachinePerWorkFrontCreateDto,
  MachinePerWorkFrontDto,
  MachinePerWorkFrontExcelDownloadDto,
  MachinePerWorkFrontUpdateDto,
} from '../proxy/controlling/dtos/machine-per-work-front';
import { MACHINEPERWORKFRONT_CONFIG, MACHINEPERWORKFRONT_FIELDS } from './machine-per-work-front.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-machine-per-work-front',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MachinePerWorkFrontService, ConfirmationService],
  templateUrl: './machine-per-work-front.html',
  styleUrl: './machine-per-work-front.scss',
})
export class MachinePerWorkFront extends BaseHierarchicalCrudComponent<
  MachinePerWorkFrontDto,
  MachinePerWorkFrontCreateDto,
  MachinePerWorkFrontUpdateDto,
  MachinePerWorkFrontExcelDownloadDto
> {
  service = inject(MachinePerWorkFrontService);
  config = MACHINEPERWORKFRONT_CONFIG;
  fields = MACHINEPERWORKFRONT_FIELDS;

  protected prepareUpdateDto(data: any, selected: MachinePerWorkFrontDto): MachinePerWorkFrontUpdateDto {
    return {
      workFrontId: data.workFrontId,
      machineId: data.machineId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MachinePerWorkFront';
  }
}
